import React from 'react';
import {Route, Routes} from "react-router-dom";
import {WebRoutes} from './Routes'
import MainPage from "./Menu/MainPage";
const AppRouter = () => {
    const CompanyData=1;
    return (
        <Routes>
            {WebRoutes.map(route=>
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.component}
                        exact={route.exact}
                    />
                )
            }
            {CompanyData?<Route path='*' element={<MainPage/>}/>:<Route path='*' element={<MainPage/>}/>}
        </Routes>
    );
};

export default AppRouter;